import { render, staticRenderFns } from "./NameListCourse.vue?vue&type=template&id=1ae366b3&"
import script from "./NameListCourse.vue?vue&type=script&lang=js&"
export * from "./NameListCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports